import { createFileRoute } from '@tanstack/react-router';
import { LegacyReportHandoff } from '@/pages/workspaces/analysis/report/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/reports` URL, which the embedded app's own nav and old
 * bookmarks still use. It only forwards to the canonical `/reports`.
 *
 * The resolver comes first because the forward is built from the pathname, so
 * a `/workspaces/last` sentinel has to land on a real id before it can go.
 */
function JourneysReportsIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <LegacyReportHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/reports/')({
  component: JourneysReportsIndexRoute,
});
